// 中文
export default {
    login_module: {
        Login: '登录',
        Register: '注册',
        noAccount: '还没有账号?',
        hasAccount: '已有账号?',
        loginSuccess:'登录成功！',
        IAgree: '我同意',
        rememberMe: '记住',
        lostPassword: '忘记密码',
        send: '发送',
        userName: '用户名',
        mailAddress: '邮箱地址',
        pwdFormat: '密码的字符长度必须在6-18个且必须包含数字、字母。',
        pwdConfirmFormat: '两次输入的密码不一致。',
        pasConfirm: '密码确认',
        pleaseInput: '请输入',
        name: '姓名',
        inputName: '请输入姓名',
        userNameFormat: '用户名只能包含字母数字字符或单个连字符，而不能以连字符开头或结尾。',
        password: '密码',
        email: '邮箱',
        inputEmail: '请输入邮箱',
        emailFormatError: '邮箱格式错误',
        enterEmail: '在下方输入e-mail，我们将发送给您重置密码的说明',
        selectCountry: '选择国家',
        verificationCode: '验证码',
        verificationFormat: '验证码格式错误',
        CountryRegion: '国家/地区',
        inputPwd: '请输入密码',
        activationPrompt: '我们将给您的邮箱发送激活邮件，请在邮箱中激活后再进行登录。'
    },
    overview_module: {
        //overview
        today: '当天',
        detectionQuantity: '检测数量',
        abnormalQuantity: '异常数量',
        dailyDetection: '每日检测量',
        detectionItems: '检测项目',
        bloodSugar: '血糖',
        bloodKetones: '血酮',
        uricAcid: '尿酸',
        lactate: '乳酸',
        mailbox: '邮箱',
        detectionTime: '检测时间',
        detectionValue: '检测值',
        unit: '单位',
        search: '搜索',
        enterName: '输入姓名',
        gender: '性别',
        male: '男',
        female: '女',
        date: '日期',
        //时段
        allGlucose: '所有血糖',
        midnight: '午夜',
        earlyMorning: '清晨',
        afterBreakfast: '早餐后',
        beforeLunch: '午餐前',
        afterLunch: '午餐后',
        beforeDinner: '晚餐前',
        afterDinner: '晚餐后',
        bedtime: '睡前'
    },
    table: {
        all: '所有',
        display: '显示',
        records: '条记录',
        unused: '未使用',
        used: '已使用',
    },
    aside: {
        //侧边栏
        overview: '总览',
        myPatients: '我的患者',
        personalInfo: '个人信息',
        allPatients: '所有病人',
        inviteCodes: '邀请码',
        code: '邀请码',
        changePwd: '修改密码',
        allDoctors: '所有医生',
        allAgent: '所有代理商',
        allInviteCodes: '所有邀请码',
        operations: '运营管理',
        feedback: '意见反馈',
        software: '软件管理'
    },
    footer: {
        service: '隐私和服务条款',
        support: '帮助'
    },
    patient_module: {
        //patient
        remind: '提醒',
        sendMsg: '发送消息',
        DMType: '糖尿病类型',
        lastUploadTime: '最后上传时间',
        device: '设备',
        lastMeasureTime: '最后检测时间',
        country: '国家',
        type1: 'I型',
        type2: 'II型',
        otherForms: '其他',
        GDM: '妊娠型',
        typePre: '糖尿病前期',
        typeSpecial: '特殊型',
    },
    patient_detail_module: {
        confirmationTime: '确诊时间',
        addNote: '添加备注',
        enterNote: '请输入备注信息',
        editNote: '编辑备注',
        confirmDeleteNote: '确定删除备注?',
        unbind: '解除关联',
        table: '表格',
        logbook: '日志',
        trends: '趋势',
        period: '时段',
        Days: '天',
        other: '其他',
        AvgDailyRange: '范围内每日平均读数',
        AvgDailyNo: '平均每日读数',
        readingRange: '范围内读数',
        avgBG: '血糖平均值',
        DerivedFrom: '来自',
        BGMReadings: '条BGM读数',
        weeks: '周',
        monday: '一',
        tuesday: '二',
        wednesday: '三',
        thursday: '四',
        friday: '五',
        saturday: '六',
        sunday: '日',
        group: '分组',
        range: '范围',
        avg: '平均值',
        min:'最低值',
        max:'最高值',
        low:'偏低',
        normal:'正常',
        high:'偏高',
        time:'次',
        patientMGT: '患者管理',
        medicine: '药品',
        food: '食物',
        sport: '运动',
        DMInfo: '糖尿病信息',
        height: '身高',
        weight: '体重',
        PreMealSugarCtrlTgt: '餐前糖控制目标',
        PostprandialSugarCtrlTgt: '餐后糖控制目标',
        info: '信息',
        useDevice: '使用设备',
        associatedDoc: '关联医生',
        associatedAgent: '关联代理商',
        lastLoginTime: '最后登录时间',
        uploadMethod: '上传方式',
        addMethod: '添加方式',
        manualAddition: '手动添加',
        realTime: '实时测量',
        historical: '历史测量',
        recordTime: '记录时间',
        dose: '剂量',
        type: '类型',
        calories: '卡路里',
        carbs: '碳水化合物',
        proteins: '蛋白质',
        fats: '脂肪',
        strength: '强度',
        duration: '时长',
        sendCustomerConfirm: '我们会将内容直接发送给客户，请反复确认。',
        selectExportedTime: '选择导出的日期',
        from: '从',
        to: '至',
        verificationCode: '验证码',
        verificationFormat: '验证码格式错误',
        DetectionStats: '检测统计',
        addedToday: '今日新增',
        addedWeek: '本周新增',
        addedMonth: '本月新增',
        remarksNoEmpty: '备注不能为空',
        selectTableTime: '选择表格数据的时间范围',
        startDate: '开始日期',
        endDate: '结束日期',
        belowRange: '读数低于范围',
        inRange: '范围内的读数',
        aboveRange: '读数高于范围',
        pleaseSelectTimeRange: '请选择时间范围！',
    },
    weekdays: {
        Sun: '星期日',
        Mon: '星期一',
        Tue: '星期二',
        Wed: '星期三',
        Thu: '星期四',
        Fri: '星期五',
        Sat: '星期六'
    },
    info_module: {
        basicInfo: '基本信息',
        avatar: '头像',
        birthday: '生日',
        chooseDate: '选择日期',
        selfIntro: '自我介绍',
        PEIntro: '职业经历介绍',
        oldPwd: '原密码',
        newPwd: '新密码',
        inputOldPwd: '请输入原密码',
        inputNewPwd: '请输入新密码',
        inputPwdAgain: '请再次输入密码'
    },
    invite_module: {
        add: '添加',
        push:"推送",
        Use: '使用情况',
        pushMail: '推送邮箱',
        remarks: '备注',
        phone:'手机',
        pushPhone: '推送手机',
        phoneInfo: '我们将发送邀请码至该手机。请提醒您的病人查收',
        creationTime: '创建时间',
        action: '操作',
        generateCode: '生成邀请码',
        codeInfo: '我们将发送邀请码至该邮箱。请提醒您的病人查收'
    },
    system_module:{
        welcome:'欢迎,@{name}!',
        welcomeMsg:'VivaGuard 将为您提供更好的血糖管理工具。您可以登录 VivaGuard App 开始记录您的血糖！',
        changePwd:'更改密码',
        changePwdFor:'为 @{name} 更改密码',
        pwdInfo:'密码必须包含一个字母、一个数字，且长度至少为6个字符。',
        resend:'重新发送',
        resendInfo:'您的账户还未被激活，我们将发送激活邮件至您的注册邮箱。',
        actived:'完成激活？',
        toLogin:'点击登录！',
        resendSuccess:'重新发送成功！',
        resendFailed:'重新发送失败！',
    },
    operation: {
        promot: '提示',
        edit: '编辑',
        save: '保存',
        yes: '确定',
        delete: '删除',
        saveSend: '保存并发送',
        rePush: '重新推送',
        cancel: '取消',
        exit: '退出',
        confirmExit: '确认退出？',
        confirmDelete: '确认删除？',
        addSuccessed: '添加成功！',
        editSuccessed: '更新成功！',
        successfullyDelete: '删除成功！'
    },
    notification:{
        1000: '令牌已过期',
        1001: '令牌已过期',
        1002: '系统错误',
        1003: '参数错误！',
        1006: '参数错误！',
        1008: '我们会向您的邮箱发送一封激活邮件。请在登录前，在您的邮箱中激活该邮件！',
        1026: '请勿重复提交！！！',
        6000: '文件过大！',
        100001: '账户已注册！',
        100002: '邮箱或密码错误。',
        100004: '账户不存在！',
        100005: '账户未激活！',
        100006: '邮件发送失败！邮箱已激活！',
        100007: '账户已被锁定！',
        100008: '原始密码错误！',
        100011: '邮件发送失败，请稍后重试！',
        200000: '验证码无效！'
    },
    back:"返回"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/zhCh.js